import styled from "livemap-ui";

export const Logo = () => (
  <Container>
    <svg viewBox="0 0 10 10" width="40" height="40">
      <path d="M5 0 l 2 4 -2 4 -2 -4z M2 6 l 2 4 -4 0z M8 6 l 2 4 -4 0z" />
    </svg>
    <LogoText>Veridict</LogoText>
  </Container>
);

const LogoText = styled.p`
  text-align: center;
  text-transform: uppercase;
  font-family: ${p => p.theme.headingFontFamily};
  font-weight: 700;
  line-height: 0.8;
  padding-top: 8px;
  font-size: 18px;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  user-select: none;

  > svg {
    width: 30px;
    height: 30px;
  }
`;
